@if (module.showMainTitle || module.minPickCount > 0) {
  <h3 [class.required]="highlightRequired">
    {{ module.name }}
    {{ module.minPickCount > 0 ? '*' : '' }}
  </h3>
}
@if (type === 'pick-one' && module.minPickCount === 1) {
  <mat-radio-group [ngModel]="radioValue" (change)="changeRadio($event.value)" [disabled]="locked">
    @for (product of module.products; track product.id) {
      <mat-radio-button [value]="product.id" color="primary">
        {{ product.productDisplayName }}
      </mat-radio-button>
    }
  </mat-radio-group>
}
@if (type === 'pick-one' && module.minPickCount === 0) {
  @for (product of module.products; track product.id) {
    <mat-checkbox color="primary" [disabled]="locked" [checked]="radioValue === product.id" (change)="changeRadioCheck(product.id)">
      {{ product.productDisplayName }}
    </mat-checkbox>
  }
}
@if (type === 'pick-many') {
  @for (product of module.products; track product.id) {
    <mat-checkbox
      color="primary"
      [disabled]="locked"
      [checked]="composition && !!composition?.moduleChoices[module.id]?.products[product.id]?.quantity"
      (change)="changeCheck(product, $event.checked)"
    >
      {{ product.productDisplayName }}
    </mat-checkbox>
  }
}
